const products = [
  {
    id: "vpn",
    name: "XEDRA VPN",
    tagline: "Secure. Private. Unrestricted.",
    description:
      "A cutting-edge VPN application engineered for iOS, offering military-grade encryption, lightning-fast server connections, and a strict no-log policy — so your digital life stays yours.",
    icon: "ri-shield-keyhole-line",
    features: [
      "AES-256 military-grade encryption",
      "Strict zero-log privacy policy",
      "One-tap secure connection",
      "Global high-speed server network",
      "Automatic kill switch protection",
      "Split tunneling for iOS",
    ],
    gradient: "from-gray-950 via-zinc-900 to-rose-950",
    accent: "text-rose-400",
    badge: "bg-rose-500/15 text-rose-300",
    imageSrc:
      "https://public.readdy.ai/ai/img_res/24a4d017a1119adade4c133dd2b081d2.jpg",
  },
  {
    id: "cleaner",
    name: "XEDRA Cleaner",
    tagline: "Clean. Optimized. Fast.",
    description:
      "An intelligent iOS cleaner that scans, removes junk files, duplicate photos, and unnecessary caches — restoring peak performance to your device with just a few taps.",
    icon: "ri-sparkling-2-line",
    features: [
      "Deep junk file removal",
      "Duplicate photo & video cleaner",
      "Smart cache optimization",
      "Memory usage analyzer",
      "Battery health monitor",
      "One-tap full device scan",
    ],
    gradient: "from-gray-950 via-zinc-900 to-emerald-950",
    accent: "text-emerald-400",
    badge: "bg-emerald-500/15 text-emerald-300",
    imageSrc:
      "https://readdy.ai/api/search-image?query=abstract%20digital%20cleaning%20optimization%20concept%20glowing%20emerald%20green%20sparkles%20particles%20flowing%20refresh%20energy%20dark%20background%20premium%20minimalist%20iOS%20app%20concept%20art%20no%20text%20no%20people%20deep%20dark%20dramatic%20teal%20glow%20sophisticated&width=480&height=320&seq=xedra-cleaner-card&orientation=landscape",
  },
];

export default function ProductsSection() {
  return (
    <section id="products" className="w-full py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Heading */}
        <div className="text-center mb-16">
          <p className="text-xs uppercase tracking-widest text-gray-400 mb-3 font-medium">
            What We Build
          </p>
          <h2 className="text-4xl md:text-5xl font-extralight text-gray-900">
            Our <span className="font-semibold">Products</span>
          </h2>
          <p className="mt-4 text-base text-gray-500 max-w-xl mx-auto leading-relaxed">
            Precision-crafted iOS applications designed to protect your privacy and keep your device running at its best.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {products.map((product) => (
            <article
              key={product.id}
              className={`relative rounded-2xl overflow-hidden bg-gradient-to-br ${product.gradient} p-8 md:p-10 flex flex-col gap-6`}
            >
              {/* Card visual */}
              <div className="w-full h-44 md:h-52 rounded-xl overflow-hidden">
                <img
                  src={product.imageSrc}
                  alt={product.name}
                  className="w-full h-full object-cover object-top"
                />
              </div>

              {/* Icon + badge */}
              <div className="flex items-center gap-3">
                <div className={`w-10 h-10 flex items-center justify-center rounded-xl bg-white/10`}>
                  <i className={`${product.icon} text-2xl ${product.accent}`} />
                </div>
                <span className={`text-xs font-medium px-3 py-1 rounded-full ${product.badge} whitespace-nowrap`}>
                  iOS Application
                </span>
              </div>

              {/* Text */}
              <div>
                <h3 className="text-2xl font-semibold text-white mb-1">{product.name}</h3>
                <p className={`text-sm font-medium mb-3 ${product.accent}`}>{product.tagline}</p>
                <p className="text-sm text-white/60 leading-relaxed">{product.description}</p>
              </div>

              {/* Features */}
              <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                {product.features.map((feat) => (
                  <li key={feat} className="flex items-start gap-2 text-sm text-white/70">
                    <i className={`ri-checkbox-circle-line mt-0.5 flex-shrink-0 ${product.accent}`} />
                    <span>{feat}</span>
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
